; (function (global, factory) {
    typeof define === 'function' && define.amd ? define('MM/Components/Teams/ContentSearch/TeamSearchSort',['eventManager', 'knockout', 'score_bootstrap/Events/SearchRequestChangeEvent'], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require('eventManager'), require('knockout'), require('score_bootstrap/Events/SearchRequestChangeEvent')) :
    console && console.error('TeamSearchSort does not support non-amd script loading.');
}(this/* window */, function (eventManager, ko, SearchRequestChangeEvent) {

    function TeamSearchSort(scope) {

        Object.defineProperty(this, 'scope',  { configurable: !0, enumerable: !0, writable: !1, value: scope });
        Object.defineProperty(this, 'selectedOption', { configurable: !0, enumerable: !0, writable: !1, value: ko.observable('') });
        Object.defineProperty(this, 'selectedOptionText', {configurable: !0, enumerable: !0, writable: !1, value: ko.observable('')});

        this.setupEventHandlers();
        this.loadInitialValues();

        ko.applyBindings(this, scope);
    }

    TeamSearchSort.prototype.setupEventHandlers = function setupEventHandlers() {

        this.selectedOption.subscribe(this._triggerSelectedOptionChanged, this);
        this.selectedOption.subscribe(this._triggerSortChanged, this);
    }

    TeamSearchSort.prototype.loadInitialValues = function loadInitialValues(){
        var initEl = this.scope.querySelector('button > span[data-preselected-value]');
        var preselectedValue = initEl.getAttribute('data-preselected-value');
        if(preselectedValue) {
            this.selectedOption(preselectedValue);
        }
    }

    TeamSearchSort.prototype._triggerSelectedOptionChanged = function _triggerSelectedOptionChanged(selectedOption) {

        var input = this.scope.querySelector('input[value=\'' + selectedOption + '\']');
        var selectedOptionText =  input.closest('.score-facet-row').querySelector('label').innerText;
        this.selectedOptionText(selectedOptionText);
    }


    TeamSearchSort.prototype._triggerSortChanged = function _triggerSortChanged(selectedOption) {
        eventManager.trigger(SearchRequestChangeEvent.customDataEvent,  {customSort: selectedOption});
    }

    TeamSearchSort.prototype.selectionOptionFromDropdown = function selectionOptionFromDropdown(el) {
        var newValue = el.getAttribute('data-value');
        this.selectedOption(newValue);
    }

    TeamSearchSort.init = function initRelatedPanel(args) {
        if (args.IsEditorEditing === true) {
            return null;
        }
        var entity = new TeamSearchSort(args.scope);
        return entity;
    }

    return TeamSearchSort;
}));
